<template>
    <div class="panel-content">
        <h2>Amsterdam UMC</h2>
        <div class="video-container">
            <iframe width="1120" height="630" src="https://www.youtube.com/embed/-pgpMawDrBQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <a @click="trackLink" class="button" href="https://www.amc.nl/web/home.htm" target="_blank">Ga naar de site!</a>
    </div>
</template>

<style lang="scss" scoped>
    .video-container{
        margin-bottom:1rem;
    }
</style>

<script>
    export default {
        methods: {
            trackLink()
            {
                window.dataLayer.push({ 'event': 'clickout', 'url': 'https://www.amc.nl/web/home.htm' });
            }
        }
    };
</script>
